/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * TAF Delivery API
 * OpenAPI spec version: 1.0
 */

export type EmploymentPageContentModelContentType = typeof EmploymentPageContentModelContentType[keyof typeof EmploymentPageContentModelContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmploymentPageContentModelContentType = {
  employmentPage: 'employmentPage',
} as const;
